module.exports = __webpack_public_path__ + "static/img/bgscimg5back.f24c617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscimg5back.png
// module id = 4bh1
// module chunks = 5